// extracted by mini-css-extract-plugin
export default {"modalRateContainer":"ModalRateDataProduct_modalRateContainer__3NQm5","rating":"ModalRateDataProduct_rating__3eOKv","label":"ModalRateDataProduct_label__3cz8I"};